// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__KQmj1","chip__text":"Chip_chip__text__JW5lZ","chip__icon":"Chip_chip__icon__rtxaA"};